// extracted by mini-css-extract-plugin
export default {"btn__wrapper":"ScrollToTop_btn__wrapper__RloVt"};